import { Call, Card, Contract, Deal, Seat } from "@ravalmatic/bridge-engine/core";

export type DevelopmentPreferences = { dealer: Seat; declarer: Seat };

export type ContractOutcome = "made" | "defeated";

export type GameData = {
    schema: number;
    musicMuted: boolean;
    sfxMuted: boolean;
    language: Language;
    difficulty: Difficulty;
    gameType: GameType;
    humanDeclares: boolean;
    playableCardHints: boolean;
    useSameSeedForEachGame: boolean;
    showLastHand: boolean;
    playerAvatarId: number;
    developmentPreferences?: DevelopmentPreferences;
}

export type PartnershipMatchState = {
    totalPoints: number;
    // Contract points towards the current game, below the line in Rubber.
    gamePoints: number;
    gamesWon: number;
    vulnerable: boolean;
};

export type MatchPartnership = "northSouth" | "eastWest";

export type RubberGameResult = {
    readonly handCount: number;
    readonly winningPartnership: MatchPartnership;
    readonly contractPoints: Readonly<Record<MatchPartnership, number>>;
    readonly points: Readonly<Record<MatchPartnership, number>>;
};

export type MatchHandResult = {
    readonly handNumber: number;
    readonly dealer: Seat;
    readonly contract: Contract | null;
    readonly declarerTricks: number;
    readonly winningPartnership: MatchPartnership | null;
    readonly points: Readonly<Record<MatchPartnership, number>>;
};

export type MatchState = {
    roundNumber: number;
    northSouth: PartnershipMatchState;
    eastWest: PartnershipMatchState;
    hands: MatchHandResult[];
    rubber: {
        games: RubberGameResult[];
        currentGame: {
            handCount: number;
            points: Record<MatchPartnership, number>;
        };
    };
};

export type BoardState = {
	seed: string;
	boardNumber: number;
	deal: Deal;
	calls: Call[];
	plays: Card[];
};

export enum HandMode {
    HIDDEN = "hidden",
    VISIBLE_READONLY = "visible-readonly",
    INTERACTIVE = "interactive",
}

export enum BoardPhase {
    BIDDING = "bidding",
    CONTRACT = "contract",
    TRANSITION = "transition",
    PLAY = "play",
    RESULT = "result",
    FINISHED = "finished",
}

export enum Language {
    EN = "en",
    ES = "es",
    DE = "de",
    FR = "fr",
    IT = "it",
    PT = "pt",
    NL = "nl",
    HI = "hi",
}

export enum Difficulty {
    EASY = "easy",
    MEDIUM = "medium",
    HARD = "hard"
}

export enum GameType {
    CHICAGO = "chicago",
    RUBBER = "rubber"
}

export enum GameEventType {
    PRELOAD_COMPLETED = "PRELOAD_COMPLETED",
    END_BIDDING_REQUESTED = "END_BIDDING_REQUESTED",
    BIDDING_FINISHED = "BIDDING_FINISHED"
}

export type BotProfile = {
    id: number;
    name?: string;
    skill: BotSkill;
}

export enum BotSkill {
    LOW = 0.3,
    MEDIUM = 0.6,
    HIGH = 1.0  
}
